import { useQuery } from 'react-query'
import { removeDefaultParams } from 'src/common/utils'
import { IFilter } from 'src/components/filter/types/filter.types'
import { QUERY_KEYS } from 'src/constants'
import { whiteLabelPartnersService } from 'src/services/white-label-partners.service'

export const initialWhiteLabelPartners = {
  query: '',
}

export const useWhiteLabelPartners = (filter?: IFilter) => {
  return useQuery(
    [QUERY_KEYS.WHITE_LABEL_PARTNERS, filter || initialWhiteLabelPartners],
    () =>
      whiteLabelPartnersService.getWhiteLabelPartners(
        removeDefaultParams(filter, initialWhiteLabelPartners),
      ),
    {
      keepPreviousData: true,
    },
  )
}
